function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLetter = function SvgLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.987 82.656"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-83.5 -186.973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.553 81.656h61.053a8.977 8.977 0 0 0 8.967-8.967V31.26a1.334 1.334 0 0 0-.691-1.169L44.864 2.133a8.938 8.938 0 0 0-11.595 0L.357 30.051a1.335 1.335 0 0 0-.771 1.209v41.429a8.978 8.978 0 0 0 8.967 8.967z",
    style: {
      fill: "#fff"
    },
    transform: "translate(84.414 187.473)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.008 240.767v1.853l-13.178 11.754-7.977 6.441-2.7 2.607s-3.309.792-3.594.792a35.231 35.231 0 0 1-4.031-1.13c-.294-.175-6.721-5.612-6.721-5.612l-15.081-12.257-2.634-2.6v-2.933h55.914z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-3.876 -15.941)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.553 81.656h61.053a8.977 8.977 0 0 0 8.967-8.967V31.26a1.334 1.334 0 0 0-.691-1.169L44.864 2.133a8.938 8.938 0 0 0-11.595 0L.357 30.051a1.335 1.335 0 0 0-.771 1.209v41.429a8.978 8.978 0 0 0 8.967 8.967zm0-2.671a6.265 6.265 0 0 1-3.812-1.29L23 59.019a1.335 1.335 0 1 0-1.909-1.867L3 75.654a6.245 6.245 0 0 1-.745-2.965V34.2L33.3 60.486a8.94 8.94 0 0 0 11.6 0l31-26.307v38.51a6.253 6.253 0 0 1-.749 2.975l-18.2-18.514a1.336 1.336 0 0 0-1.905 1.872L73.41 77.7a6.261 6.261 0 0 1-3.8 1.283zM35 4.174a6.276 6.276 0 0 1 8.141 0L75.171 31.3 43.163 58.443a6.276 6.276 0 0 1-8.14 0L2.988 31.322zm0 0",
    style: {
      fill: "#0068ff",
      stroke: "#0068ff"
    },
    transform: "translate(84.414 187.473)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7548.8 52.12V27.672h57.686V52.12",
    style: {
      stroke: "#2173ff",
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      fill: "#fff"
    },
    transform: "translate(7643.448 173.023)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.134,
    height: 3.716,
    rx: 1.858,
    style: {
      fill: "#cfe0fa"
    },
    transform: "translate(103.324 211.344)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.134,
    height: 3.716,
    rx: 1.858,
    style: {
      fill: "#cfe0fa"
    },
    transform: "translate(103.324 217.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.269,
    height: 3.716,
    rx: 1.858,
    style: {
      fill: "#cfe0fa"
    },
    transform: "translate(110.756 223.235)"
  })));
};
export default SvgLetter;